import React from 'react';
import {
  CountdownBlock, HeroBlock, StackBlock, ConversationBlock, BulletsBlock,
  FitBlock, AuthorityBlock, ReviewsBlock, FinalCtaBlock,
} from './LanderBlocks';
import {
  StepHeaderBlock, KitIntroBlock, KitOfferBlock, KitDeclineBlock,
  ThanksHeroBlock, ThreeJobsBlock, VipHeroBlock, VipMainBlock,
  TextSectionBlock, CtaBandBlock, VideoSectionBlock, TableBlock, PlansBlock, ImageMarqueeBlock, SpacerBlock,
} from './SharedBlocks';

export const REGISTRY = {
  countdown: CountdownBlock,
  hero: HeroBlock,
  stack: StackBlock,
  conversation: ConversationBlock,
  bullets: BulletsBlock,
  fit: FitBlock,
  authority: AuthorityBlock,
  reviews: ReviewsBlock,
  final_cta: FinalCtaBlock,
  step_header: StepHeaderBlock,
  kit_intro: KitIntroBlock,
  kit_offer: KitOfferBlock,
  kit_decline: KitDeclineBlock,
  thanks_hero: ThanksHeroBlock,
  three_jobs: ThreeJobsBlock,
  vip_hero: VipHeroBlock,
  vip_main: VipMainBlock,
  text_section: TextSectionBlock,
  cta_band: CtaBandBlock,
  video_section: VideoSectionBlock,
  table: TableBlock,
  plans: PlansBlock,
  image_marquee: ImageMarqueeBlock,
  spacer: SpacerBlock,
};

export const FunnelSections = ({ sections }) => (
  <>
    {(sections || []).filter((s) => s.enabled !== false).map((s) => {
      const Block = REGISTRY[s.type];
      if (!Block) return null;
      const cw = s.props && s.props.cw;
      return cw ? (
        <div key={s.id} data-vx-cw={cw}><Block id={s.id} p={s.props || {}} /></div>
      ) : (
        <Block key={s.id} id={s.id} p={s.props || {}} />
      );
    })}
  </>
);
